"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./TabPanel"), exports);
tslib_1.__exportStar(require("./Tabs"), exports);
tslib_1.__exportStar(require("./TabProps"), exports);
//# sourceMappingURL=index.js.map